import { render, staticRenderFns } from "./MonitorsList.vue?vue&type=template&id=e90aadac&scoped=true"
import script from "./MonitorsList.vue?vue&type=script&lang=js"
export * from "./MonitorsList.vue?vue&type=script&lang=js"
import style0 from "./MonitorsList.vue?vue&type=style&index=0&id=e90aadac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90aadac",
  null
  
)

export default component.exports